window.Cart = {};

Cart.init = function () {
  Cart.loadMiniCart();
  Cart.minicartTimeout = null;
  $('.header__topbar .cart > a').hover(function () {
    clearTimeout(Cart.minicartTimeout);
    MiniCart.onMouseEnter(function () {
      clearTimeout(Cart.minicartTimeout);
    });
    MiniCart.onMouseOut(function () {
      Cart.minicartTimeout = setTimeout(function () {
        MiniCart.hide();
      }, 1000);
    });
    MiniCart.show();
  }, function () {
    Cart.minicartTimeout = setTimeout(function () {
      MiniCart.hide();
    }, 1000);
  });
};

Cart.updateItemsQtyLabel = function (number) {
  var span = $('.cart a span');
  if (number === 0) {
    span.remove();
    return;
  }
  if (!span.length) {
    $('.cart a').append("<span></span>");
    span = $('.cart a span');
  }
  span.html(number);
};

Cart.loadMiniCart = function () {
  return jQuery.ajax({
    url: "/cart/fetch",
    method: "get",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      Cart.updateItemsQtyLabel(resp.itemsQty);
      MiniCart.update(resp.minicartPartial);
    }
  });
};

Cart.domodiTrackEvent = function (resp, item) {
  var i = resp.items.find(function (itemFromServer) {
    return itemFromServer._id === item.product && itemFromServer.version === item.version
  });
  if (i) {
    dmq('track', 'AddToCart', {
      id: i.mpn,
      name: i.name,
      price: i.price,
      sizes: i.sizes,
      quantity: i.qty
    });
  }
};

/**
 * Adds items on the session cart on the server side.
 *
 * @param items
 * @param options
 * @param cb
 */
Cart.addItems = function (items, options, cb) {
  if (typeof options === "function") {
    cb = options;
  } else {
    options = jQuery.extend({updateMinicart: true, showMinicart: true}, options);
  }
  jQuery.ajax({
    url: "/cart/add",
    method: "post",
    data: JSON.stringify(items),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      items.forEach(function (item) {
        if (typeof dmq !== 'undefined') {
          Cart.domodiTrackEvent(resp, item);
        }
      });
      if (options.updateMinicart) {
        Cart.loadMiniCart().then(function () {
          if (options.showMinicart) {
            MiniCart.show(true);
            setTimeout(function () {
              MiniCart.hide();
            }, 2000);
          }
        });
      }
      cb && cb(null, resp);
    },
    error: function (resp) {
      if (resp.status === 400) {
        Cart.showOutOfStockModel(resp.responseJSON.errors.cartItem.size, resp.responseJSON.errors.cartItem.version);
      }
      cb && cb(resp);
    }
  });
};

Cart.showOutOfStockModel = function (size, version) {
  var modal = $('#outOfStockModal');
  modal.find('.size').html(size || "");
  modal.find('input[name="version"]').val(version);
  modal.popup('show');
  modal.find('form [type="submit"]').click(function (evt) {
    evt.preventDefault();
    jQuery.ajax({
      url: "/shop/product/subscribe-availability",
      method: "post",
      data: JSON.stringify({
        email: modal.find('[name="email"]').val(),
        version: modal.find('[name="version"]').val()
      }),
      contentType: 'application/json; charset=utf-8',
      success: function (resp) {
        modal.popup('hide');
      },
      error: function (resp) {
        modal.popup('hide');
      }
    });
  });
};

Cart.removeItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/remove",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.plusItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/increase",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.minusItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/decrease",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.loadItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/item/get",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.updateProduct = function (item) {
  return jQuery.ajax({
    url: "/cart/item/update",
    method: "post",
    data: JSON.stringify(item),
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.clearPromoCode = function () {
  return jQuery.ajax({
    url: "/cart/promocode/clear",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

var MiniCart = Cart.MiniCart = {};

MiniCart.show = function (hasNewItem) {
  hasNewItem ? $('.minicart_object .alert').show() : $('.minicart_object .alert').hide();
  $('.minicart_object').show();
};

MiniCart.onMouseEnter = function (cb) {
  $('.minicart_object').unbind("mouseenter").mouseenter(cb);
};

MiniCart.onMouseOut = function (cb) {
  $('.minicart_object').unbind("mouseleave").mouseleave(cb);
};

MiniCart.hide = function () {
  $('.minicart_object').hide();
};

MiniCart.update = function (html) {
  $('.minicart_object').replaceWith(html);
  $('.minicart_object .item .remove').each(function (i, link) {
    $(link).click(function (event) {
      event.preventDefault();
      $(link).parent().remove();
      Cart.removeItem(this.id).then(function () {
        Cart.loadMiniCart().then(function () {
          MiniCart.show();
          MiniCart.onMouseOut(function () {
            MiniCart.hide();
          });
        })
      });
    });
  });
};